export default "__VITE_PUBLIC_ASSET__9d67e85a__"